<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div [ngClass]="isDarkMode ? 'color-scheme-dark' : 'color-scheme-light'">
  <router-outlet *ngIf="uspConfigLoaded"></router-outlet>
</div>
